import useTranslation from 'next-translate/useTranslation'
import { memo } from 'react'

import Icon from '@/atoms/Icon'
import { FansiKind } from '@/ts/Global'

import PRODUCT_FEATURES from '../data/productFeatures'

function Features({ kind }: FeaturesProps) {
  const { t } = useTranslation('products')

  return (
    <div className="space-y-4">
      {PRODUCT_FEATURES[kind].map((name, index) => (
        <div key={name} className="flex items-center space-x-4">
          <Icon
            className="w-[18px] flex-shrink-0 text-sbtviolet-550"
            name={name}
          />
          <span className="text-sm">
            {t(`product_features.${kind}.${index + 1}`)}
          </span>
        </div>
      ))}
    </div>
  )
}

interface FeaturesProps {
  kind: FansiKind
}

export default memo(Features)
